module.exports = __webpack_public_path__ + "media/bgm.a2dd9282.mp3";